import React, { useEffect, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import styled from '@emotion/styled';
import { useStore } from '@store';
import { throttle } from 'lodash-es';
import Nav from '@components/Layout/Nav';
import Footer from '@components/Layout/Footer';
import { Modal } from '@components';

const Page = ({ children, ...rest }) => {
    const {
        LayoutStore: { detectBody },
        AuthStore: { updateUserInfo },
        HomeStore: { hintModalVisible, closeHintModal, routePage },
    } = useStore();
    const detectBodyFunc = throttle(detectBody, 300);
    useEffect(() => {
        window.addEventListener('resize', detectBodyFunc);
        detectBody();
        updateUserInfo();
        return () => {
            window.removeEventListener('resize', detectBodyFunc);
        };
    }, []);

    return (
        <Container>
            <Nav />
            <Modal
                show={hintModalVisible}
                onHide={closeHintModal}
                title={'提示訊息'}
            >
                <div>
                    <div className="border-0">
                        <div className="icon_fast mx-auto "></div>
                        <div className="icon_info mx-auto mb-3"></div>
                        <h3 className=" title fw-bolder text-center mt-3 lh-base">
                            尚未開立統e貸（不限用途借貸）
                        </h3>
                        <div className="btn_box d-flex flex-column-reverse flex-sm-row justify-content-center">
                            <button
                                className="btn_check btn rounded-pill text-white"
                                type="button"
                                onClick={() => {
                                    routePage();
                                }}
                            >
                                線上開戶
                            </button>
                            <button
                                className="btn_check btn rounded-pill text-white"
                                type="button"
                                onClick={() => {
                                    closeHintModal();
                                }}
                            >
                                確認
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
            <Content {...rest}>{children}</Content>
            <Footer />
        </Container>
    );
};

export default observer(Page);
const Container = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
`;
const Content = styled.div`
    flex: 1;
`;
